import { addRequiredRule, addRequiredRuleWithMessage, removeRequiredRule, clearValidation } from "../../common/forms";
import { openDialog, dialogModel } from "../../common/dialog";

const props = {
    adminUserEditMarker:'.marker-user-management-edit',
    usertype_selector: 'input[name=UserRole]',
    accessgroupwrapper_select: '#access-group-wrapper',
    accessgroup_select: '#AccessGroupId',
    salesmanager_select: '#LineManagerId',
    salesmanager_wrapper: '#sales-manager-wrapper',
    deleteUserAccountButton: '#mdc-button--delete-user-account',
    deleteUserAccountDialog: 'mdc-dialog--delete-user-account',
    deleteUserAccountConfirmButton: '.confirm-delete-user-account',
    enableTwoFactorAuthentication: '#TwoFactorEnabled',
    twoFactorAuthenticationType: '#TwoFactorAuthenticationTypeId'
};

export function initAdminUserEdit() {
    if ($(props.adminUserEditMarker).length) {
        initViewFormEvents();
        bindDeleteUserAccount();
    }
}

function initViewFormEvents() {

    $(props.usertype_selector).off("change").on("change", function () {
        //only display user options for client users
        $(props.accessgroup_select)[0].selectedIndex = 0;

        if ($(props.usertype_selector + ':checked').val() === "CLIENT") {
            //ML, 11/06/2019. Disabled this feature as we're allowing Client accounts to be master admins (at the moment)
            //$(props.accessgroup_select + ' option[value="1"]').prop('disabled', true);
            //$(props.accessgroupwrapper_select).show(500);
        }
        else {
            //ML, 11/06/2019. Disabled this feature as we're allowing Client accounts to be master admins (at the moment)
            //$(props.accessgroup_select + ' option[value="1"]').prop('disabled', false);
            //$(props.accessgroupwrapper_select).hide(500);
        }
    });

    $(props.accessgroup_select).off("change").on("change", function () {
        //only display user options for Client users
        if ($(props.accessgroup_select).val() === "4") {
            $(props.salesmanager_wrapper).show(500);
            addRequiredRuleWithMessage($(props.salesmanager_select), "This field is required");
        }
        else {
            removeRequiredRule($(props.salesmanager_select));
            $(props.salesmanager_wrapper).hide(500);
        }
    });

    $(props.enableTwoFactorAuthentication).off('change').on('change', function () {

        //if 2FA is enabled make the 2FA type list compulsory
        if ($(this).is(':checked')) {
            addRequiredRule($(props.twoFactorAuthenticationType), true);
        }
        else {
            removeRequiredRule($(props.twoFactorAuthenticationType));
            clearValidation(props.twoFactorAuthenticationType);
        }      
    });

    //call change event after registering it to apply validation upon page load
    $(props.enableTwoFactorAuthentication).change(); 
}

function bindDeleteUserAccount(){
    $(props.deleteUserAccountButton).click(function (e) {
        e.preventDefault();
        const userId = $('#Id').val();

        openDialog({
            ...dialogModel,
            title: 'Delete User Account',
            content: 'Are you sure you want to delete this user account?',
            confirmButtonText: 'Delete',
            onConfirm: () => deleteUserAccount(userId),
            theme: 'delete'
        });
    });
}

function deleteUserAccount(userId) {
    window.location.replace('/administration/user/deleteuseraccount/' + userId);
}